<div class="modal-header">
  <h3 class="modal-form-header-title-text modal-title">{{title}}</h3>
  <a class="pull-right" (click)="bsModalRef.hide()"><i class="fa fa-close fa-2x icon"></i></a>
</div>